


















import {Vue , Component, Prop} from "vue-property-decorator";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

@Component({
    components:{
        PulseLoader
    }
})
export default class TextToSpeech extends Vue{
    @Prop({required: true, type:[String]}) readonly text: string;
    public synth = window.speechSynthesis;
    public greetingSpeech = new window.SpeechSynthesisUtterance();
    public isLoading = false;

    greet () {
        this.greetingSpeech.text = this.text;
        this.greetingSpeech.lang = 'en-US';

        this.synth.speak(this.greetingSpeech);
    }

    listenForSpeechEvents () {
        this.greetingSpeech.onstart = () => {
            this.isLoading = true
        };

        this.greetingSpeech.onend = () => {
            this.isLoading = false
        }
    }
    mounted(){
        this.listenForSpeechEvents();
    }

}
